import { render, staticRenderFns } from "./BaseColorChart.vue?vue&type=template&id=65ffabde&scoped=true&"
import script from "./BaseColorChart.vue?vue&type=script&lang=js&"
export * from "./BaseColorChart.vue?vue&type=script&lang=js&"
import style0 from "./BaseColorChart.vue?vue&type=style&index=0&id=65ffabde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ffabde",
  null
  
)

export default component.exports